import {
  ACTION_GET_OLGU_RELATION,
  OLGU_DATA_SEARCH,
  SAVE_ALL_OLGU_DATA,
  SAVE_BRAND_YARAGH_LIST_OLGU,
  SAVE_COLOR_LIST,
  SAVE_DASTE_PROFILE_LIST_TYPE,
  SAVE_DASTE_PROFILE_LIST_WITH_TYPE_STRUCT,
  SAVE_FRAME_LIST,
  SAVE_SHISHE_GROUP_LIST,
  SAVE_SHISHE_LIST,
  SAVE_TORI_LIST,
  SAVE_TYPE_COLOR_LIST_OLGU,
  SET_DATA_OLGU_FOR_EDIT,
} from "Stores/actionTypes";
import PatternService from "Services/http/endpoints/pattern/PatternService";
import StatusHandler from "Helpers/StatusHandler";
import {read} from "Helpers/LocalStorage";
import { translatorf } from "Languages/Utility/translatorf";
import showNotify from "Helpers/Notify";

export const getOlguEdit = (getOlg) => {
  return {
    type: SET_DATA_OLGU_FOR_EDIT,
    getOlg: getOlg,
  };
};

export const getOlguList = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getOlguList(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const limit = response.data.Pagination.Limit;
        const page = response.data.Pagination.Page;
        const updateData = data.map((dt, i) => {
          return {
            ...dt,
            num: ((page - 1 ) * limit) + i + 1,
          };
        });
        dispatch({
          type: SAVE_ALL_OLGU_DATA,
          allOlguData: updateData,
          allOlguDataPagination: response.data.Pagination,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getGroupProfileWithType = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getGroupProfileWithType(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        if(data.length !== 0) {
          const updateData = data.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });
          dispatch({
            type: SAVE_DASTE_PROFILE_LIST_TYPE,
            dasteProfileListWithType: updateData,
          });
          return updateData;
        } else {
          return [];
        }
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const postInsertOlgu = (data) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.postInsertOlgu(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Template_added_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getShishe = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getGlass(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt) => {
          return {
            ...dt,
            label: dt.Name,
            value: dt.Id,
          };
        });
        dispatch({
          type: SAVE_SHISHE_LIST,
          shisheList: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getShisheGroup = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getShisheGroup(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt) => {
          return {
            ...dt,
            label: dt.Name,
            value: dt.Id,
          };
        });
        dispatch({
          type: SAVE_SHISHE_GROUP_LIST,
          shisheGroupList: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getTori = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getTori(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt) => {
          return {
            ...dt,
            label: dt.Name,
            value: dt.Id,
          };
        });
        dispatch({
          type: SAVE_TORI_LIST,
          toriList: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getGroupProfile = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getGroupProfile(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt) => {
          return {
            ...dt,
            label: dt.Name,
            value: dt.Id,
          };
        });
        dispatch({
          type: SAVE_DASTE_PROFILE_LIST_WITH_TYPE_STRUCT,
          dasteProfileListWithTypeStruct: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getFrame = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getFrame(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt, index) => {
          return {
            ...dt,
            label: dt.Name,
            value: index,
          };
        });
        dispatch({
          type: SAVE_FRAME_LIST,
          frameList: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getTypeColor = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getTypeColor(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt) => {
          return {
            ...dt,
            label: dt.Name,
            value: dt.Id,
          };
        });
        dispatch({
          type: SAVE_TYPE_COLOR_LIST_OLGU,
          typeColorList: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getColor = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getColor(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt) => {
          return {
            ...dt,
            label: dt.Name,
            value: dt.Id,
          };
        });
        dispatch({
          type: SAVE_COLOR_LIST,
          colorList: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getBrandYaragh = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getBrandYaragh(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const data = response.data.Value;
        const updateData = data.map((dt) => {
          return {
            ...dt,
            label: dt.Name,
            value: dt.Id,
          };
        });
        dispatch({
          type: SAVE_BRAND_YARAGH_LIST_OLGU,
          brandYaraghList: updateData,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getAllOlgu = (params) => {
  return async () => {
    try {
      const response = await PatternService.getAllOlgu(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const deleteOlgu = (data) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.deleteOlgu(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('Pattern_deleted_successfully'),
          customClass: "success"
        });
        return true;
      } else {
        if (response.data.Message[0].Code === "RelationDelete") {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            Id: data.Id,
            Type: data.type,
            IdTemplate: data.Id,
          };
          dispatch(getRelationOlgu(params));
        }
        return false;
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getRelationOlgu = (params) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.getRelationOlgu(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch({
          type: ACTION_GET_OLGU_RELATION,
          dataRelation: response.data.Value.List,
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const getOlguForEdit = (IdTemplate, Type, params) => {
  return async (dispatch) => {
    let olgEdit = [
      {
        NameTemplate: null,
        IdGlass: 0,
        IdNet: 0,
        IdFitting: 0,
        FrameList: [],
        IdFrameList: null,
        SashList: [],
        IdSashList: null,
        SashDoorList: [],
        IdSashDoorList: null,
        MolionList: [],
        IdMolionList: null,
        OverhungList: [],
        IdOverhungList: null,
        ProfileKomakiList: [],
        IdProfileKomakiList: null,
        PaneliList: [],
        IdPaneliList: null,
        Zehvar1List: [],
        IdZehvar1List: null,
        Zehvar2List: [],
        IdZehvar2List: null,
        Zehvar3List: [],
        IdZehvar3List: null,
        MolionFrameList: [],
        IdMolionFrameList: null,
        MolionKatibehList: [],
        IdMolionKatibehList: null,
        InterlockList: [],
        IdInterlockList: null,
        ConectorSashList: [],
        IdConectorSashList: null,
        ZehvarBaranList: [],
        IdZehvarBaranList: null,
        CoverWaterList: [],
        IdCoverWaterList: null,
      },
    ];

    const rules = JSON.parse(localStorage.getItem("templateRules"));
    if (rules.accessUpdate === false) {
      dispatch(getOlguEdit(olgEdit));
    } else {
      try {
        const response = await PatternService.getOlguForEdit(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          const data = response.data.Value;

          let Items = data.Items;
          let NameTemplate = data.NameTemplate;
          let IdGlass = data.IdGlass;
          let IdNet = data.IdNet;
          let IdFitting = data.IdFitting;

          let FrameList = Items.find((fn) => fn.Namekey === "Frame");
          let IdFrameList = FrameList.SelectId;
          const updateDataFrameList = FrameList.items.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });

          let SashList = Items.find((fn) => fn.Namekey === "Sash");
          let IdSashList = SashList.SelectId;
          const updateDataSashList = SashList.items.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });

          let SashDoorList = Items.find((fn) => fn.Namekey === "SashDoor");
          let IdSashDoorList = SashDoorList.SelectId;
          const updateDataSashDoorList = SashDoorList.items.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });

          let MolionList = Items.find((fn) => fn.Namekey === "Molion");
          let IdMolionList = MolionList.SelectId;
          const updateDataMolionList = MolionList.items.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });

          let IdOverhungList = null;
          let updateDataOverhungList = [];
          if (Type === 1) {
            let OverhungList = Items.find((fn) => fn.Namekey === "Overhung");
            IdOverhungList = OverhungList.SelectId;
            updateDataOverhungList = OverhungList.items.map((dt) => {
              return {
                ...dt,
                label: dt.Name,
                value: dt.Id,
              };
            });
          }

          let ProfileKomakiList = Items.find(
              (fn) => fn.Namekey === "ProfileKomaki"
          );

          let IdProfileKomakiList = ProfileKomakiList.SelectId;
          const updateDataProfileKomakiList = ProfileKomakiList.items.map(
              (dt) => {
                return {
                  ...dt,
                  label: dt.Name,
                  value: dt.Id,
                };
              }
          );

          let PanelList = Items.find((fn) => fn.Namekey === "Panel");
          let IdPaneliList = PanelList.SelectId;
          const updateDataPanelList = PanelList.items.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });

          let Zehvar1List = Items.find((fn) => fn.Namekey === "Zehvar1");
          let IdZehvar1List = Zehvar1List.SelectId;
          const updateDataZehvar1List = Zehvar1List.items.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });

          let Zehvar2List = Items.find((fn) => fn.Namekey === "Zehvar2");
          let IdZehvar2List = Zehvar2List.SelectId;
          const updateDataZehvar2List = Zehvar2List.items.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });

          let Zehvar3List = Items.find((fn) => fn.Namekey === "Zehvar3");
          let IdZehvar3List = Zehvar3List.SelectId;
          const updateDataZehvar3List = Zehvar3List.items.map((dt) => {
            return {
              ...dt,
              label: dt.Name,
              value: dt.Id,
            };
          });

          if (Type === 2) {
            let MolionFrameList = Items.find(
                (fn) => fn.Namekey === "MolionFrame"
            );
            let IdZMolionFrameList = MolionFrameList.SelectId;
            olgEdit.MolionFrameList = MolionFrameList.items.map(
                (dt) => {
                  return {
                    ...dt,
                    label: dt.Name,
                    value: dt.Id,
                  };
                }
            );
            olgEdit.IdMolionFrameList = IdZMolionFrameList;

            let MolionKatibeList = Items.find(
                (fn) => fn.Namekey === "MolionKatibe"
            );
            let IdZMolionKatibeList = MolionKatibeList.SelectId;
            olgEdit.MolionKatibehList = MolionKatibeList.items.map(
                (dt) => {
                  return {
                    ...dt,
                    label: dt.Name,
                    value: dt.Id,
                  };
                }
            );
            olgEdit.IdMolionKatibehList = IdZMolionKatibeList;

            let InterLockList = Items.find((fn) => fn.Namekey === "InterLock");
            let IdZInterLockList = InterLockList.SelectId;
            olgEdit.InterlockList = InterLockList.items.map((dt) => {
              return {
                ...dt,
                label: dt.Name,
                value: dt.Id,
              };
            });
            olgEdit.IdInterlockList = IdZInterLockList;

            let ConectorSashList = Items.find(
                (fn) => fn.Namekey === "ConectorSash"
            );
            let IdConectorSashList = ConectorSashList.SelectId;
            olgEdit.ConectorSashList = ConectorSashList.items.map(
                (dt) => {
                  return {
                    ...dt,
                    label: dt.Name,
                    value: dt.Id,
                  };
                }
            );
            olgEdit.IdConectorSashList = IdConectorSashList;

            let ZehvarBaranList = Items.find(
                (fn) => fn.Namekey === "ZehvarBaran"
            );
            let IdZehvarBaranList = ZehvarBaranList.SelectId;
            olgEdit.ZehvarBaranList = ZehvarBaranList.items.map(
                (dt) => {
                  return {
                    ...dt,
                    label: dt.Name,
                    value: dt.Id,
                  };
                }
            );
            olgEdit.IdZehvarBaranList = IdZehvarBaranList;

            let CoverWaterList = Items.find(
                (fn) => fn.Namekey === "CoverWater"
            );
            let IdCoverWaterList = CoverWaterList.SelectId;
            olgEdit.CoverWaterList = CoverWaterList.items.map((dt) => {
              return {
                ...dt,
                label: dt.Name,
                value: dt.Id,
              };
            });
            olgEdit.IdCoverWaterList = IdCoverWaterList;
          }

          olgEdit.NameTemplate = NameTemplate;
          olgEdit.IdGlass = IdGlass;
          olgEdit.IdNet = IdNet;
          olgEdit.IdFitting = IdFitting;
          olgEdit.IdFrameList = IdFrameList;
          olgEdit.FrameList = updateDataFrameList;

          olgEdit.IdSashList = IdSashList;
          olgEdit.SashList = updateDataSashList;

          olgEdit.IdSashDoorList = IdSashDoorList;
          olgEdit.SasDoorhList = updateDataSashDoorList;

          olgEdit.IdMolionList = IdMolionList;
          olgEdit.MolionList = updateDataMolionList;

          olgEdit.IdOverhungList = IdOverhungList;
          olgEdit.OverhungList = updateDataOverhungList;

          olgEdit.IdProfileKomakiList = IdProfileKomakiList;
          olgEdit.ProfileKomakiList = updateDataProfileKomakiList;

          olgEdit.IdPaneliList = IdPaneliList;
          olgEdit.PaneliList = updateDataPanelList;

          olgEdit.IdZehvar1List = IdZehvar1List;
          olgEdit.Zehvar1List = updateDataZehvar1List;

          olgEdit.IdZehvar2List = IdZehvar2List;
          olgEdit.Zehvar2List = updateDataZehvar2List;

          olgEdit.IdZehvar3List = IdZehvar3List;
          olgEdit.Zehvar3List = updateDataZehvar3List;

          dispatch(getOlguEdit(olgEdit));
        }
      } catch (err) {
      console.error('[catch error]', err)
    }
    }
  };
};

export const updateTemplateLolaee = (
    IdTemplate,
    Type,
    Name,
    IdFrame,
    IdSash,
    IdSashDoor,
    IdMolion,
    IdOverhung,
    IdProfileKomaki,
    IdPanel,
    IdZehvar1,
    IdZehvar2,
    IdZehvar3,
    IdBrandFitting,
    IdGlass,
    IdNet,
    IdGroupProfile,
    data
) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.updateTemplateLolaee(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('The_template_was_edited_successfully'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const updateTemplateRaili = (
    IdTemplate,
    Type,
    Name,
    IdFrame,
    IdSash,
    IdSashDoor,
    IdMolion,
    IdMolionFrame,
    IdMolionKatibeh,
    IdInterlock,
    IdConectorSash,
    IdZehvarBaran,
    IdCoverWater,
    IdProfileKomaki,
    IdPanel,
    IdZehvar1,
    IdZehvar2,
    IdZehvar3,
    IdBrandFitting,
    IdGlass,
    IdNet,
    IdGroupProfile,
    data
) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.updateTemplateRaili(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        dispatch(getOlguList(IdGroupProfile));
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const disableOlgu = (data) => {
  return async (dispatch) => {
    try {
      const response = await PatternService.disableOlgu(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: translatorf('mission_accomplished'),
          customClass: "success"
        });
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };
};

export const changeOlguSearch = (allOlguDataSearch) => (dispatch) => {
  dispatch({
    type: OLGU_DATA_SEARCH,
    allOlguDataSearch: allOlguDataSearch,
  });
};
